module.exports = __webpack_public_path__ + "img/20180204173849.a5e8eccf.jpg";